import script from "./speedSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./speedSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./speedSwitch.vue?vue&type=style&index=0&id=265f9d25&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265f9d25"]])

export default __exports__